import { render, staticRenderFns } from "./ModalIndicationLimit.vue?vue&type=template&id=08ffce6d&"
import script from "./ModalIndicationLimit.vue?vue&type=script&lang=js&"
export * from "./ModalIndicationLimit.vue?vue&type=script&lang=js&"
import style0 from "./ModalIndicationLimit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports